@layer reset, default, fixed, role, wide, compact;

@layer reset {
  :host {
    display: block;

    slot {
      display: initial;
    }
  }
}

@layer default {
  :host .gcds-phase-banner {
    container: component banner / inline-size;
    font: var(--gcds-phase-banner-font);
    line-height: var(--gcds-phase-banner-line-height);

    .banner__content {
      padding: var(--gcds-phase-banner-padding);
    }

    .banner__icon {
      display: flex;
      margin: 0;

      &.icon--left {
        margin-inline-end: var(--gcds-phase-banner-icon-margin);
      }

      &.icon--right {
        margin-inline-start: var(--gcds-phase-banner-icon-margin);
      }

      ::slotted(img),
      ::slotted(svg) {
        max-height: var(--gcds-phase-banner-icon-max-height);
      }
    }

    .banner__details {
      display: flex;
      flex-wrap: wrap;
      align-items: baseline;

      ::slotted(a),
      ::slotted(gcds-button) {
        flex: 0 0 auto;
      }

      ::slotted(span),
      ::slotted(small),
      ::slotted(a) {
        font-size: 80% !important;
      }

      ::slotted(p) {
        font: var(--gcds-phase-banner-font);
        margin: 0;
      }

      ::slotted(a) {
        color: inherit;
      }

      ::slotted(gcds-button) {
        margin: var(--gcds-phase-banner-details-cta-margin);
        transform: scale(90%);
      }
    }
  }
}

@layer fixed {
  :host .gcds-phase-banner.banner-is-fixed {
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 9999;
  }
}

@layer role {
  :host .gcds-phase-banner {
    &.banner--role-primary {
      background-color: var(--gcds-phase-banner-primary-background);
      color: var(--gcds-phase-banner-primary-text);
    }

    &.banner--role-secondary {
      background-color: var(--gcds-phase-banner-secondary-background);
      color: var(--gcds-phase-banner-secondary-text);
    }
  }
}

@layer wide {
  @container banner (width >= 36em) {
    :host .gcds-phase-banner .banner__content {
      display: flex;
    }
  }
}

@layer compact {
  @container banner (width < 36em) {
    :host .gcds-phase-banner .banner__content .banner__icon {
      display: none;
    }
  }
}
